export const name = 'Oleg Dub';
export const nameUA = 'Олег Дуб';

export const specialty = [
    'Web Developer',
    'Front-end Developer',
    'React Developer',
    'Almost Fullstack Developer))',
    'Just a good guy!)',
];
export const specialtyUA = [
    'Веб-розробник',
    'Фронт Енд девелопер',
    'React розробник',
    'Майже Фулстек розробник))',
    'Просто хороший хлопець!)',
];

export const downloadCV = 'download cv';
export const downloadCVUA = 'Завантажити резюме';

export const callMe = 'call me';
export const callmeUA = 'зателефонувати';
